import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
    selector: "[window-type-4]",
    templateUrl: "./window-type-4.component.html",
    styleUrls: ["./window-type-4.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WindowType4Component {
  height = input<number>();
  windowWidth: number = 30;

  leftWindowPositions = computed(() =>
    this.generateWindows({
      columns: 4,
      initialHeight: this.height(),
      xStart: 10,
      yStart: 120,
      rowMargin: 15,
      rowHeight: 60,
      adjustMargin: true,
    })
  );

  rightWindowPositions = computed(() =>
    this.generateWindows({
      columns: 4,
      initialHeight: this.height(),
      xStart: 150,
      yStart: 165,
      rowMargin: 15,
      rowHeight: 65,
      adjustMargin: false,
    })
  );

  /**
   * Generalized method to generate window positions for both left and right sides.
   * @param config - Configuration object containing window parameters
   * @returns Array of window positions
   */
  private generateWindows(config: {
    columns: number;
    initialHeight: number;
    xStart: number;
    yStart: number;
    rowMargin: number;
    rowHeight: number;
    adjustMargin: boolean;
  }) {
    const { columns, initialHeight, xStart, yStart, rowMargin, rowHeight, adjustMargin } = config;
    const rows = Math.floor((initialHeight - (adjustMargin ? 50 : 20)) / (rowHeight + rowMargin));

    return Array.from({ length: columns }, (_, i) =>
      Array.from({ length: rows }, (_, j) => {
        const x = xStart + i * this.windowWidth;
        const y = yStart + j * rowHeight + (adjustMargin ? i * rowMargin : -i * rowMargin);
        return { x, y, isLit: Math.random() > 0.5 };
      })
    );
  }

  trackByIndex(index: number) {
    return index;
  }
}
